module.exports = __webpack_public_path__ + "img/symbol_2.85805a45.png";